//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Object.js";
import "../no/BasePart.js";
import "../no/Session.js";
let d=[[],[[["pathName","bookmarkOption","description"],"SaveWithDescription",{},3,0],[["oldPathName","newFileName","okToOverwriteExistingFile"],"Rename",{R_:{newPathName:''}},3,0],[["pathName","description"],"SetDescription",{},2,0],[["pathName"],"Delete",{},1,0]],[]];
SPLM.Gateway.BookmarkFile = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Gateway.BookmarkFile";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;